import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=0993d545&"
import script from "./VideoDetail.vue?vue&type=script&lang=js&"
export * from "./VideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./VideoDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports